<template>
  <form class="space-y-4 text-left tracking-wider">
    <div>
      <label class="block text-base font-bold mb-1 uppercase">Nome *</label>
      <input
        type="text"
        name="name"
        v-model="dataShared.state.cLogin.signUp.name"
        class="w-full bg-[#404040] text-white px-3 py-2 rounded-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-700 tracking-widest"
      />
    </div>
    <div>
      <label class="block text-base font-bold mb-1 uppercase"
        >E-mail *</label
      >
      <input
        type="email"
        name="email"
        v-model="dataShared.state.cLogin.signUp.email"
        class="w-full bg-[#404040] text-white px-3 py-2 rounded-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-700"
      />
    </div>
    <div>
      <label class="block text-base font-bold mb-1 uppercase"
        >Senha *</label
      >
      <input
        type="password"
        name="password"
        v-model="dataShared.state.cLogin.signUp.password"
        class="w-full bg-[#404040] text-white px-3 py-2 rounded-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-700"
      />
    </div>

    <button
      type="submit"
      class="w-full py-3 bg-red-700 text-white font-bold uppercase hover:bg-red-800  transition"
      @click.prevent="signUp()"
    >
      Cadastre-se
    </button>
  </form>
</template>

<script setup>
import { showToast as toast } from '@/helpers/UseToasts'
import SharedService from '@/shared/services/shared'
import { dataShared } from '@/shared/store'
import SignIn from './SignIn.vue'
import { markRaw } from 'vue'
import Events from '../../authenticated/home.vue'

async function signUp () {
  dataShared.dispatch('activeLoading')

  SharedService.signUp(dataShared.state.cLogin.signUp)
    .then(res => {
      dataShared.dispatch('desactiveLoading')
      if (res.data.success && res.data.status == 202) {
        toast(
          'Aviso',
          res.data.message,
          'info'
        )

        dataShared.state.cLogin.signIn.email = dataShared.state.cLogin.signUp.email
        return dataShared.dispatch('setComponentActiveLogin', markRaw(SignIn))
      }

      if (res.data.user) {
        dataShared.commit('SET_USER', res.data.user)
        toast('Bem-vindo', res.data.message, 'success')

        dataShared.dispatch('setComponentActive', markRaw(Events))
        window.location.href = `${process.env.VUE_APP_BASE_URL}home`
      }
    }).catch(err => {
      dataShared.dispatch('desactiveLoading')

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Não cadastrado',
        'error'
      )
    })
}
</script>
